import moment from 'moment';
import axios from 'axios';
import { ArchiveStatus, CampaignStatus } from 'App/BillingDashboard/filterOptions.enum';
import WorkOrder from '../interfaces/WorkOrder.interface';

const PATH = `${process.env.REACT_APP_API_URL}/work-order`;

axios.defaults.withCredentials = true;

interface EditWorkOrderDTO {
  endDate?: string;
  impressions?: number | null;
  isImpressionDataNeeded?: boolean;
  noImpressionDataReason?: string | null;
}

const parseStatus = (status: string) => {
  switch (status.toLowerCase()) {
    case 'not_started':
      return CampaignStatus.notStarted;
    case 'in_flight':
      return CampaignStatus.inFlight;
    case 'complete':
      return CampaignStatus.complete;
    default:
      return CampaignStatus.notStarted;
  }
};

const parseWO = (workOrder: WorkOrder) => ({
  ...workOrder,
  // isArchived: false,
  status: parseStatus(workOrder.status),
  endDate: moment(workOrder.endDate),
  createdOn: moment(workOrder.createdOn)
});

export function editWorkOrder(id: string, workOrderData: EditWorkOrderDTO) {
  if (workOrderData.noImpressionDataReason && !workOrderData.isImpressionDataNeeded) {
    workOrderData.impressions = 0;
  }
  return axios
    .patch(
      `${PATH}/${id}`,
      workOrderData
    )
    .then(response => parseWO(response.data));
}

export function archiveWorkOrders(ids: string[], archiveReason: string) {
  return axios
    .post(
      `${PATH}/archive`,
      {
        ids,
        archiveReason,
        isArchived: true
      }
    )
    .then(response => response.data);
}

export function unarchiveWorkOrders(ids: string[]) {
  return axios
    .post(
      `${PATH}/archive`,
      {
        ids,
        archiveReason: null,
        isArchived: false
      }
    )
    .then(response => response.data);
}

export function getWorkOrdersWithFilter(
  archiveStatus: ArchiveStatus,
  campaignStatuses: CampaignStatus[],
  searchText: string
): Promise<WorkOrder[]> {
  const isLookingForArchived = archiveStatus === ArchiveStatus.archived;
  const parsedCampaignStatuses = campaignStatuses.map(status => status.replace(' ', '_').toUpperCase());
  return axios
    .get(`
      ${PATH}/filter?isArchived=${isLookingForArchived}&campaignStatuses=${parsedCampaignStatuses}&text=${searchText}
    `)
    .then(response => response.data)
    .then(workOrders => workOrders && workOrders.map && workOrders.sort((a: WorkOrder, b: WorkOrder) => (a.createdOn < b.createdOn ? 1 : -1)).map(parseWO));
}
